import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MovieCard from '../components/MovieCard';
import SkeletonLoader from '../components/SkeletonLoader';
import { fetchMovieById } from '../api';

function VideoDetailPage() {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const cachedMovie = JSON.parse(localStorage.getItem(`movie-${id}`));

    if (cachedMovie) {
      setMovie(cachedMovie);
      setLoading(false);
    } else {
      const fetchSingleMovie = async () => {
        try {
          const data = await fetchMovieById(id);
          setMovie(data);
          localStorage.setItem(`movie-${id}`, JSON.stringify(data)); // 缓存数据
        } catch (err) {
          setError(err.message);
        } finally {
          setLoading(false);
        }
      };

      fetchSingleMovie();
    }

    // 预加载缩略图
    if (movie && movie.thumbnailUrl) {
      const img = new Image();
      img.src = movie.thumbnailUrl;
      img.onload = () => {
        console.log('Thumbnail loaded');
      };
    }
  }, [id]); // 注意这里移除了 movie 依赖，避免无限循环

  if (loading) return <SkeletonLoader />;
  if (error) return <p>Error: {error}</p>;
  if (!movie) return <p>Movie not found.</p>;

  return (
    <div>
      <h1>{movie.title} Details</h1>
      {/* 传递 showComments={true} 和 isDetailPage={true} 来启用评论功能并标识详细页面 */}
      <MovieCard movie={movie} showComments={true} isDetailPage={true} />
    </div>
  );
}

export default VideoDetailPage;